import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CursoOpinionRow=({cursoopinion, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{cursoopinion.comentario}</Table.Cell>
                        <Table.Cell>{cursoopinion.pais}</Table.Cell>
                        <Table.Cell textAlign="center">{cursoopinion.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/cursoopinion/"+cursoopinion.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(cursoopinion.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={cursoopinion.idEstatus==1?'x':'check'} link  size="large" 
                                                color={cursoopinion.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(cursoopinion.id)} 
                                            />
                                        }
                                        content={cursoopinion.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default CursoOpinionRow;